import React from 'react'
import { useDevice } from 'device'

import { useFeaturedBrandNavigationData } from 'modules/brands'

import { Href } from 'components/navigation'
import { buttonMessages } from 'components/inputs'
import { BackgroundImage } from 'components/dataDisplay'

import BannerBase from '../BannerBase/BannerBase'

import s from './FeaturedBrandBanner.scss'


type FeaturedBrandBannerProps = {
  onClick?: () => void
  placement: BrandsModule.FeaturedBrandNavigationBannerPlacement
  'data-testid'?: string
}

function isStrapiBanner(banner: BrandsModule.FeaturedBrandNavigationBannerData): banner is BrandsModule.StrapiFeaturedBrandNavigationBannerData {
  return Boolean((banner as BrandsModule.StrapiFeaturedBrandNavigationBannerData).isStrapi)
}

const FeaturedBrandBanner: React.FunctionComponent<FeaturedBrandBannerProps> = (props) => {
  const { placement, onClick, 'data-testid': dataTestId = 'brandsBanner' } = props

  const { isMobile } = useDevice()

  const featuredBrandNavigationData = useFeaturedBrandNavigationData()
  const featuredBrandNavigationBannerData = featuredBrandNavigationData?.banners?.[placement]

  if (!featuredBrandNavigationBannerData) {
    return null
  }

  if (isStrapiBanner(featuredBrandNavigationBannerData)) {
    const { to, background } = featuredBrandNavigationBannerData

    return (
      <Href to={to} onClick={onClick} data-testid={dataTestId}>
        <BackgroundImage
          className="flex flex-col items-start justify-center bg-gray-70 p-32"
          src={isMobile ? background?.mobile : background?.desktop}
          style={{ backgroundPosition: '0 50%', height: '296rem' }}
        />
      </Href>
    )
  }

  const { background, buttonStyle, logo, name, text, textColor, to } = featuredBrandNavigationBannerData

  return (
    <BannerBase
      bgImage={background}
      buttonStyle={buttonStyle}
      buttonTitle={buttonMessages.learnMore}
      content="Featured brand"
      logo={logo}
      logoClassName={s.logo}
      text={text}
      textColor={textColor}
      to={to}
      trackParams={{ productBrand: name }}
      onClick={onClick}
      data-testid={dataTestId}
    />
  )
}

export default FeaturedBrandBanner
